import { render, staticRenderFns } from "./provincias.vue?vue&type=template&id=38d39eb2"
import script from "./provincias.vue?vue&type=script&lang=js"
export * from "./provincias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports